var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneBlueFillLarge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.875,
    height: 31.8,
    viewBox: "0 0 19.875 31.8",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-fill",
    d: "M3,3.975A3.975,3.975,0,0,1,6.975,0H18.9a3.975,3.975,0,0,1,3.975,3.975v23.85A3.975,3.975,0,0,1,18.9,31.8H6.975A3.975,3.975,0,0,1,3,27.825ZM14.925,25.837a1.987,1.987,0,1,1-1.987-1.987A1.987,1.987,0,0,1,14.925,25.837Z",
    transform: "translate(-3)",
    fill: "#126cfc",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneBlueFillLarge);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS44NzUiIGhlaWdodD0iMzEuOCIgdmlld0JveD0iMCAwIDE5Ljg3NSAzMS44Ij4KICA8cGF0aCBpZD0icGhvbmUtZmlsbCIgZD0iTTMsMy45NzVBMy45NzUsMy45NzUsMCwwLDEsNi45NzUsMEgxOC45YTMuOTc1LDMuOTc1LDAsMCwxLDMuOTc1LDMuOTc1djIzLjg1QTMuOTc1LDMuOTc1LDAsMCwxLDE4LjksMzEuOEg2Ljk3NUEzLjk3NSwzLjk3NSwwLDAsMSwzLDI3LjgyNVpNMTQuOTI1LDI1LjgzN2ExLjk4NywxLjk4NywwLDEsMS0xLjk4Ny0xLjk4N0ExLjk4NywxLjk4NywwLDAsMSwxNC45MjUsMjUuODM3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMpIiBmaWxsPSIjMTI2Y2ZjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";